const jobalert = ({ brandEnum  }) => {
    return {

        count: 0,

        queryContainer: {
            searchQuery: '',
            location: '',
            aroundRadius: 20000
        },

        subscribePayload: {
            language: 'nl',
            brandEnum: null,
            email: '',
            name: '',
            frequency: 1
        },

        subscribeResponse: null,
        unsubscribeResponse: null,

        loading: false,

        get displayForm() {
            return this.subscribeResponse == null || this.subscribeResponse.status == 409;
        },

        get displaySuccess() {
            return this.subscribeResponse != null && this.subscribeResponse.status == 200;
        },

        get displayConflict() {
            return this.subscribeResponse != null && this.subscribeResponse.status == 409;
        },

        get displayError() {
            return this.subscribeResponse != null && this.subscribeResponse.status != 200 &&
                this.subscribeResponse.status != 409;
        },

        get displayUnsubscribeForm() {
            return this.unsubscribeResponse == null;
        },

        get displayUnsubscribeSuccess() {
            return this.unsubscribeResponse != null && this.unsubscribeResponse.status == 200;
        },

        get displayUnsubscribeError() {
            return this.unsubscribeResponse != null && this.unsubscribeResponse.status != 200 &&
                this.unsubscribeResponse.status != 409;
        },

        init() {
            if (typeof brandEnum !== 'undefined') {
                this.subscribePayload.brandEnum = brandEnum;
            }

            this.$watch('queryContainer', () => {
                this.getCount();
            });

            this.getCount();
        },

        getCount() {
            const payload = JSON.stringify(this.queryContainer);

            fetch('/_ajax/jobalert/count', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: payload
            })
                .then((response) => response.text())
                .then((data) => this.count = data);
        },

        subscribe() {
            this.loading = true;

            const command = { ...this.subscribePayload, ...this.queryContainer };
            const payload = JSON.stringify(command);

            fetch('/_ajax/jobalert/subscribe', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: payload
            })
                .then((response) => {
                    this.subscribeResponse = response;
                })
                .then((data) => {
                    // console.log(data); // Uncomment to see the jobalertId
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        unsubscribe(jobalertId) {
            this.loading = true;

            fetch('/_ajax/jobalert/unsubscribe/single?jobalertId=' + jobalertId, {
                method: 'DELETE',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            })
                .then((response) => {
                    this.unsubscribeResponse = response;
                })
                .then((_) => {
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        unsubscribeAll(email) {
            this.loading = true;

            fetch('/_ajax/jobalert/unsubscribe/all?email=' + email, {
                method: 'DELETE',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            })
                .then((response) => {
                    this.unsubscribeResponse = response;
                })
                .then((_) => {
                })
                .finally(() => {
                    this.loading = false;
                });
        }

    };
};

export { jobalert };